var _rect, _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _circle4, _circle5, _circle6, _path11, _path12, _path13, _rect22, _rect23, _rect24, _rect25, _circle7, _circle8, _path14, _path15, _path16, _path17, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCostlyErrors(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 559,
    height: 543,
    viewBox: "0 0 559 543",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 78.0001,
    y: 361,
    width: 294,
    height: 182,
    rx: 10,
    fill: "white",
    fillOpacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 391,
    r: 6,
    fill: "#FC165B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 391,
    r: 6,
    fill: "#FCA016"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 391,
    r: 6,
    fill: "#16FCA9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.842 417.928L122.378 422.992L117.842 428.056L116.594 426.992L118.442 424.968C118.661 424.728 118.879 424.507 119.098 424.304C119.317 424.096 119.549 423.912 119.794 423.752H106.89V422.232H119.802C119.535 422.061 119.306 421.888 119.114 421.712C118.927 421.531 118.703 421.299 118.442 421.016L116.594 418.992L117.842 417.928ZM138.277 426.84C138.837 426.84 139.283 426.741 139.613 426.544C139.944 426.341 140.109 426.064 140.109 425.712C140.109 425.483 140.061 425.288 139.965 425.128C139.869 424.968 139.677 424.819 139.389 424.68C139.101 424.541 138.664 424.397 138.077 424.248C137.523 424.104 137.035 423.933 136.613 423.736C136.197 423.539 135.875 423.283 135.645 422.968C135.416 422.653 135.301 422.248 135.301 421.752C135.301 421.027 135.603 420.443 136.205 420C136.813 419.552 137.637 419.328 138.677 419.328C139.387 419.328 140.005 419.421 140.533 419.608C141.061 419.795 141.512 420.027 141.885 420.304L141.133 421.432C140.803 421.213 140.44 421.035 140.045 420.896C139.656 420.757 139.216 420.688 138.725 420.688C138.155 420.688 137.744 420.773 137.493 420.944C137.248 421.115 137.125 421.341 137.125 421.624C137.125 421.837 137.187 422.013 137.309 422.152C137.437 422.291 137.656 422.421 137.965 422.544C138.275 422.667 138.712 422.805 139.277 422.96C139.827 423.109 140.304 423.285 140.709 423.488C141.12 423.691 141.437 423.96 141.661 424.296C141.891 424.627 142.005 425.059 142.005 425.592C142.005 426.2 141.829 426.699 141.477 427.088C141.125 427.472 140.667 427.757 140.101 427.944C139.536 428.125 138.928 428.216 138.277 428.216C137.493 428.216 136.816 428.104 136.245 427.88C135.675 427.651 135.195 427.365 134.805 427.024L135.757 425.936C136.088 426.203 136.467 426.421 136.893 426.592C137.32 426.757 137.781 426.84 138.277 426.84ZM147.871 426.84C148.431 426.84 148.876 426.741 149.207 426.544C149.538 426.341 149.703 426.064 149.703 425.712C149.703 425.483 149.655 425.288 149.559 425.128C149.463 424.968 149.271 424.819 148.983 424.68C148.695 424.541 148.258 424.397 147.671 424.248C147.116 424.104 146.628 423.933 146.207 423.736C145.791 423.539 145.468 423.283 145.239 422.968C145.01 422.653 144.895 422.248 144.895 421.752C144.895 421.027 145.196 420.443 145.799 420C146.407 419.552 147.231 419.328 148.271 419.328C148.98 419.328 149.599 419.421 150.127 419.608C150.655 419.795 151.106 420.027 151.479 420.304L150.727 421.432C150.396 421.213 150.034 421.035 149.639 420.896C149.25 420.757 148.81 420.688 148.319 420.688C147.748 420.688 147.338 420.773 147.087 420.944C146.842 421.115 146.719 421.341 146.719 421.624C146.719 421.837 146.78 422.013 146.903 422.152C147.031 422.291 147.25 422.421 147.559 422.544C147.868 422.667 148.306 422.805 148.871 422.96C149.42 423.109 149.898 423.285 150.303 423.488C150.714 423.691 151.031 423.96 151.255 424.296C151.484 424.627 151.599 425.059 151.599 425.592C151.599 426.2 151.423 426.699 151.071 427.088C150.719 427.472 150.26 427.757 149.695 427.944C149.13 428.125 148.522 428.216 147.871 428.216C147.087 428.216 146.41 428.104 145.839 427.88C145.268 427.651 144.788 427.365 144.399 427.024L145.351 425.936C145.682 426.203 146.06 426.421 146.487 426.592C146.914 426.757 147.375 426.84 147.871 426.84ZM156.185 415.984V420.584C156.526 420.168 156.924 419.856 157.377 419.648C157.836 419.435 158.31 419.328 158.801 419.328C159.596 419.328 160.188 419.549 160.577 419.992C160.966 420.435 161.161 421.051 161.161 421.84V428H159.369V422.12C159.369 421.613 159.273 421.251 159.081 421.032C158.889 420.808 158.58 420.696 158.153 420.696C157.753 420.696 157.382 420.827 157.041 421.088C156.7 421.344 156.414 421.635 156.185 421.96V428H154.393V416.176L156.185 415.984ZM173.66 428V426.72H174.9V420.824H173.66V419.552H176.268L176.596 421.512C176.911 420.803 177.3 420.264 177.764 419.896C178.234 419.523 178.836 419.336 179.572 419.336C179.823 419.336 180.047 419.357 180.244 419.4C180.447 419.437 180.647 419.488 180.844 419.552L180.54 422.664H179.26V420.944C178.663 420.965 178.148 421.205 177.716 421.664C177.284 422.117 176.943 422.757 176.692 423.584V426.72H178.396V428H173.66ZM186.558 419.328C187.795 419.328 188.739 419.731 189.39 420.536C190.041 421.341 190.366 422.416 190.366 423.76C190.366 424.656 190.217 425.437 189.918 426.104C189.625 426.771 189.193 427.291 188.622 427.664C188.057 428.032 187.366 428.216 186.55 428.216C185.318 428.216 184.374 427.819 183.718 427.024C183.062 426.224 182.734 425.141 182.734 423.776C182.734 422.901 182.881 422.131 183.174 421.464C183.473 420.792 183.907 420.269 184.478 419.896C185.049 419.517 185.742 419.328 186.558 419.328ZM186.558 420.72C185.913 420.72 185.427 420.968 185.102 421.464C184.777 421.955 184.614 422.725 184.614 423.776C184.614 424.827 184.774 425.6 185.094 426.096C185.419 426.587 185.905 426.832 186.55 426.832C187.195 426.832 187.678 426.584 187.998 426.088C188.323 425.592 188.486 424.816 188.486 423.76C188.486 422.72 188.326 421.955 188.006 421.464C187.686 420.968 187.203 420.72 186.558 420.72ZM196.152 419.328C197.389 419.328 198.333 419.731 198.984 420.536C199.635 421.341 199.96 422.416 199.96 423.76C199.96 424.656 199.811 425.437 199.512 426.104C199.219 426.771 198.787 427.291 198.216 427.664C197.651 428.032 196.96 428.216 196.144 428.216C194.912 428.216 193.968 427.819 193.312 427.024C192.656 426.224 192.328 425.141 192.328 423.776C192.328 422.901 192.475 422.131 192.768 421.464C193.067 420.792 193.501 420.269 194.072 419.896C194.643 419.517 195.336 419.328 196.152 419.328ZM196.152 420.72C195.507 420.72 195.021 420.968 194.696 421.464C194.371 421.955 194.208 422.725 194.208 423.776C194.208 424.827 194.368 425.6 194.688 426.096C195.013 426.587 195.499 426.832 196.144 426.832C196.789 426.832 197.272 426.584 197.592 426.088C197.917 425.592 198.08 424.816 198.08 423.76C198.08 422.72 197.92 421.955 197.6 421.464C197.28 420.968 196.797 420.72 196.152 420.72ZM209.418 427.552C209.108 427.749 208.738 427.909 208.306 428.032C207.874 428.155 207.423 428.216 206.954 428.216C205.972 428.216 205.226 427.963 204.714 427.456C204.207 426.944 203.954 426.272 203.954 425.44V420.856H202.074V419.552H203.954V417.664L205.746 417.448V419.552H208.594L208.394 420.856H205.746V425.424C205.746 425.877 205.858 426.216 206.082 426.44C206.311 426.659 206.684 426.768 207.202 426.768C207.511 426.768 207.794 426.731 208.05 426.656C208.311 426.581 208.551 426.485 208.77 426.368L209.418 427.552ZM215.091 416.736C216.094 416.736 216.913 416.915 217.547 417.272C218.187 417.624 218.683 418.109 219.035 418.728C219.387 419.347 219.633 420.056 219.771 420.856C219.91 421.651 219.979 422.491 219.979 423.376C219.979 424.72 219.913 425.845 219.779 426.752C219.651 427.653 219.414 428.331 219.067 428.784C218.721 429.243 218.219 429.472 217.563 429.472C217.131 429.472 216.777 429.349 216.499 429.104C216.227 428.859 216.025 428.56 215.891 428.208C215.758 427.861 215.683 427.531 215.667 427.216H215.603C215.443 427.6 215.187 427.952 214.835 428.272C214.489 428.592 214.009 428.752 213.395 428.752C212.798 428.752 212.318 428.592 211.955 428.272C211.593 427.952 211.329 427.517 211.163 426.968C210.998 426.413 210.915 425.787 210.915 425.088C210.915 423.728 211.19 422.691 211.739 421.976C212.294 421.256 213.099 420.896 214.155 420.896C214.55 420.896 214.939 420.944 215.323 421.04C215.713 421.131 216.131 421.296 216.579 421.536V426.288C216.579 427.051 216.665 427.56 216.835 427.816C217.011 428.072 217.238 428.2 217.515 428.2C217.803 428.2 218.006 428.008 218.123 427.624C218.246 427.24 218.321 426.693 218.347 425.984C218.374 425.275 218.387 424.427 218.387 423.44C218.387 422.651 218.342 421.928 218.251 421.272C218.166 420.611 218.003 420.04 217.763 419.56C217.529 419.08 217.193 418.709 216.755 418.448C216.318 418.187 215.75 418.056 215.051 418.056C214.513 418.056 213.945 418.157 213.347 418.36C212.755 418.563 212.131 418.952 211.475 419.528L210.611 418.528C211.337 417.899 212.07 417.443 212.811 417.16C213.558 416.877 214.318 416.736 215.091 416.736ZM214.179 422.112C213.566 422.112 213.147 422.352 212.923 422.832C212.699 423.312 212.587 424.064 212.587 425.088C212.587 425.851 212.665 426.448 212.819 426.88C212.974 427.307 213.257 427.52 213.667 427.52C213.993 427.52 214.246 427.445 214.427 427.296C214.609 427.147 214.745 426.971 214.835 426.768C214.926 426.56 214.995 426.379 215.043 426.224V422.32C214.777 422.181 214.489 422.112 214.179 422.112ZM228.605 426.592V428H221.925V426.592H224.621V418.8L222.189 420.296L221.421 419.04L224.813 416.96H226.397V426.592H228.605ZM234.071 416.736C234.818 416.736 235.452 416.877 235.975 417.16C236.498 417.437 236.895 417.813 237.167 418.288C237.444 418.757 237.583 419.28 237.583 419.856C237.583 420.341 237.498 420.816 237.327 421.28C237.162 421.739 236.892 422.224 236.519 422.736C236.151 423.243 235.663 423.808 235.055 424.432C234.447 425.051 233.703 425.76 232.823 426.56H237.839L237.631 428H230.767V426.64C231.759 425.685 232.575 424.875 233.215 424.208C233.86 423.541 234.364 422.965 234.727 422.48C235.095 421.995 235.354 421.557 235.503 421.168C235.652 420.773 235.727 420.373 235.727 419.968C235.727 419.413 235.57 418.976 235.255 418.656C234.94 418.336 234.503 418.176 233.943 418.176C233.447 418.176 233.031 418.267 232.695 418.448C232.364 418.629 232.036 418.923 231.711 419.328L230.543 418.44C230.975 417.891 231.471 417.469 232.031 417.176C232.591 416.883 233.271 416.736 234.071 416.736ZM243.633 416.736C244.363 416.736 244.993 416.864 245.521 417.12C246.049 417.376 246.454 417.715 246.737 418.136C247.019 418.557 247.161 419.021 247.161 419.528C247.161 420.211 246.95 420.779 246.529 421.232C246.113 421.685 245.593 421.984 244.969 422.128C245.427 422.176 245.849 422.304 246.233 422.512C246.622 422.72 246.931 423.016 247.161 423.4C247.395 423.784 247.513 424.267 247.513 424.848C247.513 425.477 247.347 426.048 247.017 426.56C246.686 427.067 246.222 427.469 245.625 427.768C245.027 428.067 244.323 428.216 243.513 428.216C242.819 428.216 242.158 428.088 241.529 427.832C240.905 427.576 240.374 427.189 239.937 426.672L241.033 425.712C241.347 426.08 241.713 426.352 242.129 426.528C242.55 426.704 242.985 426.792 243.433 426.792C244.115 426.792 244.657 426.616 245.057 426.264C245.457 425.907 245.657 425.413 245.657 424.784C245.657 424.069 245.459 423.571 245.065 423.288C244.67 423 244.158 422.856 243.529 422.856H242.577L242.785 421.536H243.457C243.974 421.536 244.425 421.395 244.809 421.112C245.198 420.824 245.393 420.384 245.393 419.792C245.393 419.259 245.209 418.848 244.841 418.56C244.478 418.267 244.027 418.12 243.489 418.12C243.025 418.12 242.614 418.205 242.257 418.376C241.899 418.547 241.547 418.792 241.201 419.112L240.249 418.096C240.734 417.637 241.259 417.296 241.825 417.072C242.39 416.848 242.993 416.736 243.633 416.736ZM252.154 426.664C252.154 426.237 252.301 425.875 252.594 425.576C252.893 425.272 253.261 425.12 253.698 425.12C254.136 425.12 254.504 425.272 254.802 425.576C255.101 425.875 255.25 426.237 255.25 426.664C255.25 427.091 255.101 427.456 254.802 427.76C254.504 428.064 254.136 428.216 253.698 428.216C253.261 428.216 252.893 428.064 252.594 427.76C252.301 427.456 252.154 427.091 252.154 426.664ZM265.796 421.112V424.064H267.108V425.456H265.796V428H264.076L264.068 425.456H259.484V424.208L262.66 416.736L264.172 417.336L261.356 424.064H264.076L264.292 421.112H265.796ZM276.054 416.96L275.822 418.304H271.582V421.376C271.897 421.211 272.201 421.099 272.494 421.04C272.793 420.976 273.091 420.944 273.39 420.944C273.977 420.944 274.499 421.083 274.958 421.36C275.417 421.637 275.777 422.037 276.038 422.56C276.305 423.083 276.438 423.715 276.438 424.456C276.438 425.197 276.273 425.851 275.942 426.416C275.617 426.981 275.155 427.424 274.558 427.744C273.966 428.059 273.273 428.216 272.478 428.216C271.758 428.216 271.118 428.088 270.558 427.832C270.003 427.571 269.515 427.216 269.094 426.768L270.166 425.76C270.779 426.448 271.526 426.792 272.406 426.792C273.078 426.792 273.606 426.589 273.99 426.184C274.379 425.773 274.574 425.195 274.574 424.448C274.574 423.637 274.403 423.072 274.062 422.752C273.721 422.427 273.291 422.264 272.774 422.264C272.497 422.264 272.235 422.296 271.99 422.36C271.75 422.419 271.483 422.509 271.19 422.632H269.87V416.96H276.054ZM283.144 416.736C283.592 416.736 284.002 416.797 284.376 416.92C284.754 417.037 285.101 417.2 285.416 417.408L284.72 418.56C284.245 418.251 283.722 418.096 283.152 418.096C282.394 418.096 281.792 418.448 281.344 419.152C280.896 419.851 280.65 420.811 280.608 422.032C280.954 421.573 281.341 421.243 281.768 421.04C282.2 420.832 282.658 420.728 283.144 420.728C283.714 420.728 284.234 420.861 284.704 421.128C285.178 421.389 285.557 421.784 285.84 422.312C286.122 422.835 286.264 423.488 286.264 424.272C286.264 425.061 286.104 425.752 285.784 426.344C285.469 426.936 285.037 427.397 284.488 427.728C283.938 428.053 283.314 428.216 282.616 428.216C281.693 428.216 280.949 427.987 280.384 427.528C279.824 427.069 279.416 426.437 279.16 425.632C278.904 424.827 278.776 423.904 278.776 422.864C278.776 421.637 278.949 420.565 279.296 419.648C279.648 418.725 280.149 418.011 280.8 417.504C281.45 416.992 282.232 416.736 283.144 416.736ZM282.768 422.072C282.33 422.072 281.928 422.189 281.56 422.424C281.197 422.659 280.885 422.971 280.624 423.36C280.645 424.555 280.808 425.437 281.112 426.008C281.421 426.573 281.925 426.856 282.624 426.856C283.237 426.856 283.693 426.627 283.992 426.168C284.296 425.704 284.448 425.099 284.448 424.352C284.448 423.504 284.296 422.912 283.992 422.576C283.688 422.24 283.28 422.072 282.768 422.072ZM290.529 426.664C290.529 426.237 290.676 425.875 290.969 425.576C291.268 425.272 291.636 425.12 292.073 425.12C292.511 425.12 292.879 425.272 293.177 425.576C293.476 425.875 293.625 426.237 293.625 426.664C293.625 427.091 293.476 427.456 293.177 427.76C292.879 428.064 292.511 428.216 292.073 428.216C291.636 428.216 291.268 428.064 290.969 427.76C290.676 427.456 290.529 427.091 290.529 426.664ZM300.763 428.192L299.075 427.672L303.307 418.368H298.251V416.96H305.123V418.248L300.763 428.192ZM314.717 419.592C314.717 420.125 314.562 420.584 314.253 420.968C313.944 421.352 313.485 421.712 312.877 422.048C313.608 422.373 314.17 422.787 314.565 423.288C314.96 423.789 315.157 424.368 315.157 425.024C315.157 425.616 315.002 426.155 314.693 426.64C314.384 427.12 313.936 427.504 313.349 427.792C312.768 428.075 312.061 428.216 311.229 428.216C310.402 428.216 309.701 428.075 309.125 427.792C308.554 427.509 308.12 427.131 307.821 426.656C307.528 426.176 307.381 425.645 307.381 425.064C307.381 424.408 307.576 423.845 307.965 423.376C308.354 422.907 308.874 422.525 309.525 422.232C308.944 421.923 308.514 421.576 308.237 421.192C307.96 420.803 307.821 420.301 307.821 419.688C307.821 419.032 307.989 418.485 308.325 418.048C308.666 417.611 309.101 417.283 309.629 417.064C310.157 416.845 310.706 416.736 311.277 416.736C311.88 416.736 312.442 416.843 312.965 417.056C313.488 417.269 313.909 417.587 314.229 418.008C314.554 418.429 314.717 418.957 314.717 419.592ZM309.557 419.696C309.557 420.24 309.741 420.637 310.109 420.888C310.477 421.133 310.997 421.371 311.669 421.6C312.128 421.323 312.461 421.04 312.669 420.752C312.877 420.464 312.981 420.107 312.981 419.68C312.981 419.184 312.834 418.787 312.541 418.488C312.248 418.189 311.826 418.04 311.277 418.04C310.733 418.04 310.309 418.184 310.005 418.472C309.706 418.76 309.557 419.168 309.557 419.696ZM313.325 425.032C313.325 424.584 313.218 424.227 313.005 423.96C312.797 423.693 312.496 423.469 312.101 423.288C311.706 423.107 311.234 422.92 310.685 422.728C310.28 422.936 309.933 423.219 309.645 423.576C309.357 423.933 309.213 424.411 309.213 425.008C309.213 425.573 309.384 426.024 309.725 426.36C310.066 426.691 310.576 426.856 311.253 426.856C311.936 426.856 312.45 426.68 312.797 426.328C313.149 425.976 313.325 425.544 313.325 425.032ZM319.311 426.664C319.311 426.237 319.457 425.875 319.751 425.576C320.049 425.272 320.417 425.12 320.855 425.12C321.292 425.12 321.66 425.272 321.959 425.576C322.257 425.875 322.407 426.237 322.407 426.664C322.407 427.091 322.257 427.456 321.959 427.76C321.66 428.064 321.292 428.216 320.855 428.216C320.417 428.216 320.049 428.064 319.751 427.76C319.457 427.456 319.311 427.091 319.311 426.664ZM330.328 416.752C331.587 416.752 332.531 417.16 333.16 417.976C333.79 418.787 334.104 419.869 334.104 421.224C334.104 422.317 333.982 423.259 333.736 424.048C333.496 424.832 333.123 425.499 332.616 426.048C332.115 426.597 331.472 427.059 330.688 427.432C329.91 427.805 328.979 428.125 327.896 428.392L327.504 427.08C328.955 426.691 330.064 426.179 330.832 425.544C331.6 424.904 332.056 424.013 332.2 422.872C331.875 423.224 331.512 423.507 331.112 423.72C330.712 423.933 330.251 424.04 329.728 424.04C329.126 424.04 328.587 423.899 328.112 423.616C327.643 423.328 327.27 422.92 326.992 422.392C326.72 421.864 326.584 421.237 326.584 420.512C326.584 419.717 326.75 419.04 327.08 418.48C327.411 417.92 327.859 417.493 328.424 417.2C328.995 416.901 329.63 416.752 330.328 416.752ZM328.408 420.512C328.408 421.291 328.568 421.851 328.888 422.192C329.214 422.533 329.643 422.704 330.176 422.704C330.598 422.704 330.974 422.605 331.304 422.408C331.635 422.211 331.95 421.936 332.248 421.584C332.243 420.352 332.094 419.467 331.8 418.928C331.512 418.384 331.019 418.112 330.32 418.112C329.702 418.112 329.227 418.312 328.896 418.712C328.571 419.112 328.408 419.712 328.408 420.512ZM340.05 416.736C341.287 416.736 342.223 417.235 342.858 418.232C343.493 419.229 343.81 420.64 343.81 422.464C343.81 424.299 343.493 425.717 342.858 426.72C342.223 427.717 341.287 428.216 340.05 428.216C338.813 428.216 337.877 427.717 337.242 426.72C336.607 425.717 336.29 424.299 336.29 422.464C336.29 420.64 336.607 419.229 337.242 418.232C337.877 417.235 338.813 416.736 340.05 416.736ZM340.05 418.104C339.415 418.104 338.927 418.443 338.586 419.12C338.245 419.792 338.074 420.907 338.074 422.464C338.074 423.6 338.143 424.485 338.282 425.12L341.402 418.752C341.247 418.523 341.058 418.357 340.834 418.256C340.61 418.155 340.349 418.104 340.05 418.104ZM342.026 422.464C342.026 421.445 341.97 420.632 341.858 420.024L338.778 426.312C339.066 426.669 339.49 426.848 340.05 426.848C340.69 426.848 341.178 426.512 341.514 425.84C341.855 425.168 342.026 424.043 342.026 422.464Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.385 476H109.616C107.067 476 105 478.066 105 480.615V483.385C105 485.934 107.067 488 109.616 488H112.385C114.934 488 117 485.934 117 483.385V480.615C117 478.066 114.934 476 112.385 476Z",
    fill: "white",
    fillOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M176.328 476H128.672C126.092 476 124 478.066 124 480.615V483.385C124 485.934 126.092 488 128.672 488H176.328C178.908 488 181 485.934 181 483.385V480.615C181 478.066 178.908 476 176.328 476Z",
    fill: "white",
    fillOpacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M229.306 476H192.694C190.102 476 188 478.066 188 480.615V483.385C188 485.934 190.102 488 192.694 488H229.306C231.899 488 234 485.934 234 483.385V480.615C234 478.066 231.899 476 229.306 476Z",
    fill: "white",
    fillOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M163.368 500H109.632C107.074 500 105 502.066 105 504.615V507.385C105 509.934 107.074 512 109.632 512H163.368C165.926 512 168 509.934 168 507.385V504.615C168 502.066 165.926 500 163.368 500Z",
    fill: "white",
    fillOpacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M222.357 500H179.643C177.079 500 175 502.066 175 504.615V507.385C175 509.934 177.079 512 179.643 512H222.357C224.921 512 227 509.934 227 507.385V504.615C227 502.066 224.921 500 222.357 500Z",
    fill: "white",
    fillOpacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M300.395 500H239.605C237.062 500 235 502.066 235 504.615V507.385C235 509.934 237.062 512 239.605 512H300.395C302.938 512 305 509.934 305 507.385V504.615C305 502.066 302.938 500 300.395 500Z",
    fill: "white",
    fillOpacity: 0.05
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M144.417 452H109.583C107.052 452 105 454.066 105 456.615V459.385C105 461.934 107.052 464 109.583 464H144.417C146.948 464 149 461.934 149 459.385V456.615C149 454.066 146.948 452 144.417 452Z",
    fill: "white",
    fillOpacity: 0.05
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M218.417 452H161.583C159.052 452 157 454.066 157 456.615V459.385C157 461.934 159.052 464 161.583 464H218.417C220.948 464 223 461.934 223 459.385V456.615C223 454.066 220.948 452 218.417 452Z",
    fill: "white",
    fillOpacity: 0.05
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M292.352 452H235.648C233.081 452 231 454.066 231 456.615V459.385C231 461.934 233.081 464 235.648 464H292.352C294.919 464 297 461.934 297 459.385V456.615C297 454.066 294.919 452 292.352 452Z",
    fill: "white",
    fillOpacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 116.265,
    y: 12,
    width: 1.86023,
    height: 488.311,
    fill: "url(#paint0_linear_59_690)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 68.8287,
    y: 12,
    width: 1.86023,
    height: 488.311,
    fill: "url(#paint1_linear_59_690)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 162.771,
    y: 12,
    width: 1.86023,
    height: 488.311,
    fill: "url(#paint2_linear_59_690)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 209.276,
    y: 12,
    width: 1.86023,
    height: 488.311,
    fill: "url(#paint3_linear_59_690)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 255.782,
    y: 12,
    width: 1.86023,
    height: 488.311,
    fill: "url(#paint4_linear_59_690)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 302.288,
    y: 12,
    width: 1.86023,
    height: 488.311,
    fill: "url(#paint5_linear_59_690)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 348.794,
    y: 12,
    width: 1.86023,
    height: 488.311,
    fill: "url(#paint6_linear_59_690)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 395.3,
    y: 12,
    width: 1.86023,
    height: 488.311,
    fill: "url(#paint7_linear_59_690)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 441.805,
    y: 12,
    width: 1.86023,
    height: 488.311,
    fill: "url(#paint8_linear_59_690)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 488.311,
    y: 12,
    width: 1.86023,
    height: 488.311,
    fill: "url(#paint9_linear_59_690)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 559,
    y: 92.9204,
    width: 1.86023,
    height: 559,
    transform: "rotate(90 559 92.9204)",
    fill: "url(#paint10_linear_59_690)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 559,
    y: 45.4844,
    width: 1.86023,
    height: 559,
    transform: "rotate(90 559 45.4844)",
    fill: "url(#paint11_linear_59_690)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 559,
    y: 139.426,
    width: 1.86023,
    height: 559,
    transform: "rotate(90 559 139.426)",
    fill: "url(#paint12_linear_59_690)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 559,
    y: 185.932,
    width: 1.86023,
    height: 559,
    transform: "rotate(90 559 185.932)",
    fill: "url(#paint13_linear_59_690)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 559,
    y: 232.438,
    width: 1.86023,
    height: 559,
    transform: "rotate(90 559 232.438)",
    fill: "url(#paint14_linear_59_690)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 559,
    y: 278.944,
    width: 1.86023,
    height: 559,
    transform: "rotate(90 559 278.944)",
    fill: "url(#paint15_linear_59_690)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 559,
    y: 325.449,
    width: 1.86023,
    height: 559,
    transform: "rotate(90 559 325.449)",
    fill: "url(#paint16_linear_59_690)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 559,
    y: 371.955,
    width: 1.86023,
    height: 559,
    transform: "rotate(90 559 371.955)",
    fill: "url(#paint17_linear_59_690)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 559,
    y: 418.461,
    width: 1.86023,
    height: 559,
    transform: "rotate(90 559 418.461)",
    fill: "url(#paint18_linear_59_690)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 559,
    y: 464.967,
    width: 1.86023,
    height: 559,
    transform: "rotate(90 559 464.967)",
    fill: "url(#paint19_linear_59_690)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 273,
    cy: 228,
    r: 65,
    fill: "white",
    fillOpacity: 0.05
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 273,
    cy: 228,
    r: 53,
    fill: "white",
    fillOpacity: 0.1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 273,
    cy: 228,
    r: 37,
    fill: "white",
    fillOpacity: 0.15
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M273 244.667C282.205 244.667 289.667 237.205 289.667 228C289.667 218.795 282.205 211.333 273 211.333C263.795 211.333 256.333 218.795 256.333 228C256.333 237.205 263.795 244.667 273 244.667Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M256.333 228H289.667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M273 211.333C277.169 215.897 279.538 221.82 279.667 228C279.538 234.18 277.169 240.103 273 244.667C268.831 240.103 266.462 234.18 266.333 228C266.462 221.82 268.831 215.897 273 211.333V211.333Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    width: 198,
    height: 60,
    rx: 10,
    fill: "white",
    fillOpacity: 0.05
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 310.5,
    y: 0.5,
    width: 197,
    height: 59,
    rx: 9.5,
    stroke: "white",
    strokeOpacity: 0.1
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 80,
    width: 198,
    height: 60,
    rx: 10,
    fill: "white",
    fillOpacity: 0.05
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 310.5,
    y: 80.5,
    width: 197,
    height: 59,
    rx: 9.5,
    stroke: "white",
    strokeOpacity: 0.1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 8,
    transform: "matrix(1 0 0 -1 338 30)",
    fill: "#66FFA3"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    r: 8,
    transform: "matrix(1 0 0 -1 338 110)",
    fill: "white",
    fillOpacity: 0.4
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M216.5 356.5C214 356.5 212 358.5 212 361C212 363.5 214 365.5 216.5 365.5C219 365.5 221 363.5 221 361C221 358.5 219 356.5 216.5 356.5Z",
    fill: "#6016FC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M213.5 361C213.5 359.328 214.829 358 216.5 358V355C213.172 355 210.5 357.672 210.5 361H213.5ZM216.5 358C218.172 358 219.5 359.328 219.5 361H222.5C222.5 357.672 219.829 355 216.5 355V358ZM219.5 361C219.5 362.672 218.172 364 216.5 364V367C219.829 367 222.5 364.328 222.5 361H219.5ZM216.5 364C214.829 364 213.5 362.672 213.5 361H210.5C210.5 364.328 213.172 367 216.5 367V364ZM218 356.5V347H215V356.5H218ZM236.5 328.5H253V325.5H236.5V328.5ZM274.5 307V293H271.5V307H274.5ZM253 328.5C264.874 328.5 274.5 318.874 274.5 307H271.5C271.5 317.217 263.217 325.5 253 325.5V328.5ZM218 347C218 336.783 226.283 328.5 236.5 328.5V325.5C224.626 325.5 215 335.126 215 347H218Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M310 105.5C307.5 105.5 305.5 107.5 305.5 110C305.5 112.5 307.5 114.5 310 114.5C312.5 114.5 314.5 112.5 314.5 110C314.5 107.5 312.5 105.5 310 105.5Z",
    fill: "#6016FC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M307 110C307 108.328 308.329 107 310 107V104C306.672 104 304 106.672 304 110H307ZM310 107C311.672 107 313 108.328 313 110H316C316 106.672 313.329 104 310 104V107ZM313 110C313 111.672 311.672 113 310 113V116C313.329 116 316 113.328 316 110H313ZM310 113C308.329 113 307 111.672 307 110H304C304 113.328 306.672 116 310 116V113ZM305.5 108.5H293V111.5H305.5V108.5ZM271.5 130V163H274.5V130H271.5ZM293 108.5C281.126 108.5 271.5 118.126 271.5 130H274.5C274.5 119.783 282.783 111.5 293 111.5V108.5Z",
    fill: "white",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_59_690",
    x1: 117.195,
    y1: 12,
    x2: 117.195,
    y2: 500.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_59_690",
    x1: 69.7589,
    y1: 12,
    x2: 69.7589,
    y2: 500.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_59_690",
    x1: 163.701,
    y1: 12,
    x2: 163.701,
    y2: 500.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_59_690",
    x1: 210.206,
    y1: 12,
    x2: 210.206,
    y2: 500.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_59_690",
    x1: 256.712,
    y1: 12,
    x2: 256.712,
    y2: 500.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_59_690",
    x1: 303.218,
    y1: 12,
    x2: 303.218,
    y2: 500.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_59_690",
    x1: 349.724,
    y1: 12,
    x2: 349.724,
    y2: 500.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_59_690",
    x1: 396.23,
    y1: 12,
    x2: 396.23,
    y2: 500.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_59_690",
    x1: 442.736,
    y1: 12,
    x2: 442.736,
    y2: 500.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_59_690",
    x1: 489.241,
    y1: 12,
    x2: 489.241,
    y2: 500.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_59_690",
    x1: 559.93,
    y1: 92.9204,
    x2: 559.93,
    y2: 651.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_59_690",
    x1: 559.93,
    y1: 45.4844,
    x2: 559.93,
    y2: 604.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_59_690",
    x1: 559.93,
    y1: 139.426,
    x2: 559.93,
    y2: 698.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_59_690",
    x1: 559.93,
    y1: 185.932,
    x2: 559.93,
    y2: 744.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_59_690",
    x1: 559.93,
    y1: 232.438,
    x2: 559.93,
    y2: 791.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_59_690",
    x1: 559.93,
    y1: 278.944,
    x2: 559.93,
    y2: 837.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_59_690",
    x1: 559.93,
    y1: 325.449,
    x2: 559.93,
    y2: 884.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_59_690",
    x1: 559.93,
    y1: 371.955,
    x2: 559.93,
    y2: 930.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_59_690",
    x1: 559.93,
    y1: 418.461,
    x2: 559.93,
    y2: 977.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_59_690",
    x1: 559.93,
    y1: 464.967,
    x2: 559.93,
    y2: 1023.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostlyErrors);
export default __webpack_public_path__ + "static/media/costlyErrors.ad95dad65728731eb7e78907b9263337.svg";
export { ForwardRef as ReactComponent };